const SITE_URL = import.meta.env.VITE_SHAREPOINT_SITE_URL;

export function isSharePointConfigured(): boolean {
  return !!SITE_URL;
}

/** Deep-link to a SharePoint list, optionally filtered by event name. */
export function getSharePointListUrl(listName: string, eventFilter?: string): string {
  const base = `${SITE_URL}/Lists/${encodeURIComponent(listName)}/AllItems.aspx`;
  if (!eventFilter) return base;
  // SharePoint URL filter syntax
  return `${base}?FilterField1=Event&FilterValue1=${encodeURIComponent(eventFilter)}`;
}

// ── Specific list helpers ──────────────────────────────────────────────────

export function getEventRosterUrl(eventName?: string): string {
  return getSharePointListUrl("Event Roster", eventName);
}

export function getSessionsListUrl(eventName?: string): string {
  return getSharePointListUrl("Sessions", eventName);
}

export function getEventsListUrl(): string {
  return getSharePointListUrl("Events");
}

export function getUsersDirectoryUrl(): string {
  return getSharePointListUrl("Users Directory");
}

export function getNotificationsLogUrl(eventName?: string): string {
  return getSharePointListUrl("Notifications Log", eventName);
}

export function getSurveyResponsesUrl(eventName?: string): string {
  return getSharePointListUrl("Survey Results", eventName);
}

/** SharePoint site home page (HomeBranded.aspx), authored by setupSharePointHomePage. */
export function getSharePointHomeUrl(): string {
  return `${SITE_URL}/SitePages/HomeBranded.aspx`;
}

/** Per-event hub page provisioned by the eventPages Cloud Function trigger. */
export function getEventPageUrl(eventId: string): string {
  return `${SITE_URL}/SitePages/Event-${encodeURIComponent(eventId)}.aspx`;
}
